// extracted by mini-css-extract-plugin
export var fullWidth = "layout-module--full-width--WOWwe";
export var mainWrapper = "layout-module--main-wrapper--pKVD7";